import React from "react";
import { Helmet } from 'react-helmet-async';

function AboutUs() {
  return (
    <div className="p-8 max-w-4xl mx-auto">
      
<Helmet>
                <title>About</title>
                <meta name="description" content="About us" />
            </Helmet>
      <h1 className="text-3xl font-bold mb-4">About Us</h1>
      <p className="text-gray-700 mb-4">
        Welcome to Pro Prime Mart! We are happy to provide you with  the best high-quality vending machines,supplements,magic mushroom spores,whey protein for strenght,muscle enhancements, and many more items from over 50 stores and 700 products.
      </p>
      <p className="text-gray-700">
        Our mission is to be the number #1 place where you come to get the best products only from the best stores. check out our products page to choose the products that best suits your needs.
        If you wish to become a vendor and sell with us,please kindly contact us.You will be duely guided on which part to follow.
      </p>
      <p>With Pro Prime Mart[Shop the best from the best] </p>
    </div>
  );
}

export default AboutUs;
